import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomFilterTabs from "../../../../Components/CustomFilterTabs";

const FilterTabs = ({ activeTab, setActiveTab }) => {
  const { t } = useTranslation("pricelist-search");

  const handleTabChange = (_, newValue) => setActiveTab(newValue);

  const tabsArr = [
    {
      label: t("tabs.services_fixes"),
      value: "services",
      iconPath: "/icons/toolbox-repair-icon.svg",
      disabled: false,
    },
    {
      label: t("tabs.products_shops"),
      value: "products",
      iconPath: "/icons/store-line-icon.svg",
      disabled: false,
    },
    {
      label: t("tabs.food_restaurants"),
      value: "food",
      iconPath: "/icons/bowl-food-icon.svg",
      disabled: false,
    },
    {
      label: t("tabs.coupons_deals"),
      value: "coupons",
      iconPath: "/icons/coupon-icon.svg",
      disabled: true,
      soonBadge: true,
    },
  ];

  return (
    <Box
      sx={{
        marginBottom: "40px",
        borderBottom: 1,
        borderColor: "rgba(0, 0, 0, 0.1)",
      }}
    >
      <CustomFilterTabs
        tabs={tabsArr}
        activeTab={activeTab}
        onChange={handleTabChange}
        tabItemStyles={{
          px: 0,
          py: "12px",
          marginRight: "32px",
        }}
      />
    </Box>
  );
};

export default FilterTabs;
